import type { PropsWithChildren, FC } from 'react';

import { buttonInnerStyle, chevronIconWrapperStyle } from './ButtonInner.css';
import { ChevronRightFatIcon } from '../../icons';
import { hasIcon } from '../../util/children';

const buttonInnerClassName = 'button-inner';

export const ButtonInner: FC<PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <span className={`${buttonInnerStyle} ${buttonInnerClassName}`}>
      {children}
      {!hasIcon(children) && (
        <span className={chevronIconWrapperStyle}>
          <ChevronRightFatIcon></ChevronRightFatIcon>
        </span>
      )}
    </span>
  );
};

ButtonInner.displayName = 'ButtonInner';
